import React from 'react';
import Link from 'shared/Link.jsx';
import SearchContainer from './SearchContainer.jsx';
import SearchResultContainer from './SearchResultContainer.jsx';

const AdminHome = () => (
  <div className="animated fadeIn">
    <div className="row">
      <div className="col-md-8 col-md-offset-2 text-right">
        <Link
          className="btn btn-primary btn-lg"
          to="admin/squads"
        >{'Reserve Squads'}</Link>
      </div>
    </div>
    <br />
    <div className="row">
      <div className="col-md-8 col-md-offset-2">
        <SearchContainer />
      </div>
    </div>
    <br />
    <SearchResultContainer />
  </div>
);

export default AdminHome;



// WEBPACK FOOTER //
// ./src/features/admin/home/AdminHome.jsx